import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

interface Service {
  id: number;
  name_ar: string;
  name_en: string;
  slug: string;
  icon: string | null;
  description: string | null;
}

const serviceEmojis: Record<string, string> = {
  veterinary: '🏥', transport: '🚛', feed: '🌾', shearing: '✂️', breeding: '🧬', slaughter: '🔪',
};

const ServicesPage: React.FC = () => {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/services')
      .then((res) => setServices(res.data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '28px 24px 40px', boxSizing: 'border-box', fontFamily: "'Tajawal', sans-serif", color: '#17241F' }} dir="rtl">
      <nav aria-label="مسار التنقل" style={{ display: 'flex', gap: 8, fontSize: 13, color: '#6E7C76' }}>
        <Link to="/" style={{ textDecoration: 'none', color: '#6E7C76' }}>الرئيسية</Link><span>›</span><span>الخدمات</span>
      </nav>
      <h1 style={{ margin: '14px 0 6px', fontFamily: "'Cairo', sans-serif", fontSize: 32, fontWeight: 800 }}>الخدمات</h1>
      <p style={{ margin: '0 0 24px', fontSize: 16, color: '#5D6B65' }}>خدمات متنوعة للمواشي والحلال</p>

      {loading ? (
        <p style={{ color: '#9AA6A1', textAlign: 'center', padding: '40px 0' }}>جاري التحميل...</p>
      ) : services.length === 0 ? (
        <div style={{ background: '#FFFFFF', borderRadius: 20, border: '1px solid #E6ECE9', padding: 48, textAlign: 'center', color: '#9AA6A1' }}>لا توجد خدمات حالياً</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 16 }}>
          {services.map((service) => (
            <Link key={service.id} to={'/ads?service_id=' + service.id}
              style={{ padding: '26px 18px', borderRadius: 20, background: '#FFFFFF', border: '1px solid #E6ECE9', textDecoration: 'none', color: '#17241F', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, textAlign: 'center', transition: 'box-shadow .15s' }}
              onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,40,32,0.08)')}
              onMouseLeave={(e) => (e.currentTarget.style.boxShadow = 'none')}>
              <span style={{ width: 72, height: 72, borderRadius: 20, background: '#FBF4E6', color: '#B8893C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>
                {serviceEmojis[service.slug] || '🔧'}
              </span>
              <span style={{ fontFamily: "'Cairo', sans-serif", fontSize: 18, fontWeight: 700 }}>{service.name_ar}</span>
              {service.name_en && <span style={{ fontSize: 13, color: '#8A9792' }} dir="ltr">{service.name_en}</span>}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServicesPage;
